// external deps
import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { ContentCard } from 'ypf-pas-general-ui-components';

// internal deps
import useLoading from "../../hooks/useLoading";
import useApp from "../../hooks/useApp";
import { getItemStorage, clearStorage } from "../../utils/utils";
import { constantsSession } from "../../constants/constants";
import { URL_SERVICIOS } from "../../constants/host";
import styles from "./HomeContainer.module.scss";
import useHomeUtils from "../../hooks/useHomeUtils";

function HomeContainer() {
  const { setLoading } = useLoading();
  const { appsURL, provName } = useApp();
  const { getAllowedLinks} = useHomeUtils();
  const roles = getItemStorage(constantsSession.ROLES_ME);
  const accessToken = getItemStorage(constantsSession.ACCESS_TOKEN, false);
  const expireIn = getItemStorage(
    constantsSession.ACCESS_TOKEN_EXPIRE_IN,
    false
  );
  const refreshToken = getItemStorage(constantsSession.REFRESH_TOKEN, false);
  const accessTokenDate = getItemStorage(
    constantsSession.ACCESS_TOKEN_DATE,
    false
  );

  const yClickLinks = getAllowedLinks( appsURL, roles);
  const queryNRisNotificationReport = getItemStorage("hmnr_isnr");
  // If the user was redirected to Home from a notification report URL
  // they must be redirected to Services before rendering Home

  const notificationReportRedirect = () => {
    const queryNRContractNumber = encodeURIComponent(getItemStorage("hmnr_cn"));
    const queryNRWell = encodeURIComponent(getItemStorage("hmnr_wl"));
    const queryNRDateFrom = encodeURIComponent(getItemStorage("hmnr_df"));
    const queryNRDateTo = encodeURIComponent(getItemStorage("hmnr_dt"));

    clearStorage();
    // Default value based on the parameters
    // Redirect to NotFound if the POST request fails
    const nrUrl = `${URL_SERVICIOS}/notification-report/?at=${accessToken}&ei=${expireIn}&rt=${refreshToken}&atd=${accessTokenDate}&nr_cn=${queryNRContractNumber}&nr_wl=${queryNRWell}&nr_df=${queryNRDateFrom}&nr_dt=${queryNRDateTo}`;
    const navigator = window.location;

    navigator.replace(nrUrl);
  };

  if (queryNRisNotificationReport === "1") {
    notificationReportRedirect();
  }

  useEffect(() => {
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return queryNRisNotificationReport === "1" ? null : (
    <div className="pas-container fluid-75">
      <ContentCard orientation="vertical" className={`${styles.contentModule}`}>
        <div className="p-3">
          <h2 className={styles.cardTitle}>Gestión de Servicios</h2>
          <Row className="my-5">
            {yClickLinks.map((yClickLink, index) => (
              <React.Fragment key={index}>
                <Col sm={3}>
                  <h3 className={`${styles.colTitle} pt-3`}>
                    {yClickLink.title}
                  </h3>
                  <div className="liner" />
                  {yClickLink.links.map((l, i, arr) => (
                    <React.Fragment key={i}>
                      <div className={`d-block p-2 ${styles.links}`}>
                        {l.isDownload ? (
                            <div
                              className="link-to-download"
                              onClick={() => l.actionDownload()}
                            >
                              {l.name}
                            </div>
                          ): (
                            <a
                            href={
                              l.url === "#"
                                ? ""
                                : `${l.url}?at=${accessToken}&ei=${expireIn}&rt=${refreshToken}&atd=${accessTokenDate}&ispr=${provName}`
                            }
                            onClick={() => clearStorage()}
                          >
                            {l.name}
                          </a>
                          )}
          
                      </div>
                      {i === arr.length - 1 ? null : <div className="liner" />}
                    </React.Fragment>
                  ))}
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </ContentCard>
    </div>
  );
}

export default HomeContainer;
